import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectZandloperXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M3 1.5C3 1.78 3.22 2 3.5 2H12.5C12.78 2 13 1.78 13 1.5C13 1.22 12.78 1 12.5 1H3.5C3.22 1 3 1.22 3 1.5Z' />
    <path d='M13 14.5C13 14.22 12.78 14 12.5 14H3.5C3.22 14 3 14.22 3 14.5C3 14.78 3.22 15 3.5 15H12.5C12.78 15 13 14.78 13 14.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5 3C11.78 3 12 3.22 12 3.5V5.5L12.01 5.49C12.01 5.91 11.85 6.48 11.13 6.89L9.07 7.99L11.12 9.09C11.85 9.5 12 10.08 12 10.49V12.49C12 12.77 11.78 12.99 11.5 12.99H4.5C4.22 12.99 4 12.77 4 12.49V10.49C4 9.91 4.32 9.41 4.89 9.09L10.64 6.01C10.96 5.83 11 5.64 11 5.49V3.99H5V5.49C5 5.58 5 5.8 5.38 6.02L6.95 6.86L5.89 7.43L4.9 6.9C4.32 6.57 4 6.08 4 5.5V3.5C4 3.22 4.22 3 4.5 3H11.5ZM11 10.5C11 10.35 10.95 10.15 10.63 9.97V9.98L8 8.57L5.37 9.98C5 10.19 5 10.42 5 10.5V12H11V10.5Z'
    />
  </svg>
);
export default SvgDefectZandloperXs;
